import TeamTransfer from '@/screens/TeamTransfer';

export default function PrivateTeamTeamIdEditTransferIndexRoute() {
  return <TeamTransfer />;
}
